import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let RobotIcon = ({ color = true, ...props }) => (
	<SvgIcon {...props} viewBox="0 -960 960 960">
		<path d="M160-120v-200q0-33 23.5-56.5T240-400h480q33 0 56.5 23.5T800-320v200H160Zm200-320q-83 0-141.5-58.5T160-640q0-83 58.5-141.5T360-840h240q83 0 141.5 58.5T800-640q0 83-58.5 141.5T600-440H360ZM240-200h480v-120H240v120Zm120-320h240q50 0 85-35t35-85q0-50-35-85t-85-35H360q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0-80q17 0 28.5-11.5T400-640q0-17-11.5-28.5T360-680q-17 0-28.5 11.5T320-640q0 17 11.5 28.5T360-600Zm240 0q17 0 28.5-11.5T640-640q0-17-11.5-28.5T600-680q-17 0-28.5 11.5T560-640q0 17 11.5 28.5T600-600ZM480-200Zm0-440Z" />
	</SvgIcon>
);
RobotIcon = memo(RobotIcon);
RobotIcon.displayName = "RobotIcon";
RobotIcon.muiName = "RobotIcon";

export default RobotIcon;
